import { cpqAxiosWithToken } from '../http-common';
import { Congiguration } from '../Constants/AppConstants';

class ManageDataService {
    
    getSessionUsageMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/SessionUsageMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getStaffTimeMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/StaffTimeMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getDeliveryStaffProductivityMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/DeliveryStaffProductivityMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getStaffCostDeptMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/StaffCostDeptMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getServiceDistributionMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/ServiceDistributionMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getExternalCostsMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/ExternalCostsMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getOverheadCostsMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/OverheadCostsMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getWebCostsMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/WebCostsMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getProductMarginMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/ProductMarginMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getProductPricingModelMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/ProductPricingModelMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getRRCIAndTrainingPricingMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/RRCIAndTrainingMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getAdditionalCounselingPricingMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/AdditionalCounselingPricingMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getPathwaysPricingTableMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/PathwaysPricingMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getGWQPricingMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/GWQPricingMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getNPRTWPricingMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/NPRTWPricingMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getCurrencyMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/CurrencyConversionMasterData?companyId=${Congiguration.CompanyId}`);
    }
    getEnhancedLandFAvailabilityMasterData() {
        
        return cpqAxiosWithToken.get(`MasterData/EnhancedLAndFMasterData?companyId=${Congiguration.CompanyId}`);
    }
    saveSessionUsageMasterData(SessionUsageMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/SessionUsageMasterData", SessionUsageMasterData);
    }
    saveStaffTimeMasterData(StaffTimeMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/StaffTimeMasterData", StaffTimeMasterData);
    }
    saveDeliveryStaffProductivityMasterData(DeliveryStaffProductivityMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/DeliveryStaffProductivityMasterData", DeliveryStaffProductivityMasterData);
    }
    saveStaffCostDeptMasterData(StaffCostDeptMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/StaffCostDeptMasterData", StaffCostDeptMasterData);
    }
    saveServiceDistributionMasterData(ServiceDistributionMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/ServiceDistributionMasterData", ServiceDistributionMasterData);
    }
    saveExternalCostsMasterData(ExternalCostsMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/ExternalCostsMasterData", ExternalCostsMasterData);
    }
    saveOverheadCostsMasterData(OverheadCostsMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/OverheadCostsMasterData", OverheadCostsMasterData);
    }
    saveWebCostasterData(WebCostasterData) {
       
        return cpqAxiosWithToken.post("MasterData/WebCostasterData", WebCostasterData);
    }
    saveStaffTimeMasterData(StaffTimeMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/StaffTimeMasterData", StaffTimeMasterData);
    }
    saveProductMarginMasterData(ProductMarginMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/ProductMarginMasterData", ProductMarginMasterData);
    }
    saveProductPricingModelMasterData(ProductPricingModelMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/ProductPricingModelMasterData", ProductPricingModelMasterData);
    }
    saveRRCIAndTrainingMasterData(RRCIAndTrainingMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/RRCIAndTrainingMasterData", RRCIAndTrainingMasterData);
    }
    saveAdditionalCounselingPricingMasterData(AdditionalCounselingPricingMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/AdditionalCounselingPricingMasterData", AdditionalCounselingPricingMasterData);
    }
    savePathwaysPricingTableMasterData(PathwaysPricingTableMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/PathwaysPricingTableMasterData", PathwaysPricingTableMasterData);
    }
    saveGWQPricingMasterData(GWQPricingMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/GWQPricingMasterData", GWQPricingMasterData);
    }
    saveNPRTWPricingMasterData(NPRTWPricingMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/NPRTWPricingMasterData", NPRTWPricingMasterData);
    }
    saveCurrencyMasterData(CurrencyMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/CurrencyConversionMasterData", CurrencyMasterData);
    }

    saveEnhancedLandFAvailabilityMasterData(EnhancedLandFAvailabilityMasterData) {
       
        return cpqAxiosWithToken.post("MasterData/EnhancedLAndFMasterData", EnhancedLandFAvailabilityMasterData);
    }
    
}

export default new ManageDataService();